import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=046355eb&scoped=true"
import script from "./modal.ts?vue&type=script&lang=ts&external"
export * from "./modal.ts?vue&type=script&lang=ts&external"
import style0 from "./modal.vue?vue&type=style&index=0&id=046355eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046355eb",
  null
  
)

export default component.exports